import { type yup } from '@framework/validation/initYup.ts';
import { type Widget } from '../../schema/widgets/Widget.ts';

export const WidgetTypeInternalMetaKey = 'widgetType@internal';

/**
 * Funzione che ritorna lo schema impostando nel meta il widgetType
 * relativo al widget in oggetto. In questo modo, è possibile sapere
 * il tipo di widget collegato ad ogni valore nel form anche attraverso
 * la `forEachSchemaNode()`.
 */
export function setWidgetTypeMeta(schema: yup.AnySchema, widget: Widget) {
  return schema.meta({
    [WidgetTypeInternalMetaKey]: widget.type,
  });
}

export function getWidgetTypeMeta(
  schema: yup.AnySchema | null | undefined,
): string | undefined {
  return schema?.meta()?.[WidgetTypeInternalMetaKey];
}
